const CheckCanBoThuHoi= (canBoCoTheThuHoiInfo) => {

  let check = false;

  if (canBoCoTheThuHoiInfo && localStorage.getItem('userInfo')) {

    let data = JSON.parse(localStorage.getItem('userInfo'));

    if (canBoCoTheThuHoiInfo.giaTri == data.id) {
      check = true;
    }
  }
  return check;
}

export { CheckCanBoThuHoi };


// WEBPACK FOOTER //
// ./src/components/modules/login/CheckCanBoThuHoi.js